<template>
	<Layout>
		<Infos />
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import Infos from '@js/components/SwissLeague/Infos';

export default {
	name:       'ViewSwissLeagueinfos',
	components: { Layout, Infos },
};
</script>

<style>

</style>
